// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sq-5";
export var filledCircle = "_sq-4";
export var historyEntry = "_sq-3";
export var messageSideLeft = "_sq-1";
export var messageSideRight = "_sq-2";
export var orderTrackingCarouselWrapper = "_sq-6";
export var orderTrackingInfoContainer = "_sq-0";